import React, { useState } from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row, Col, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import "react-datetime/css/react-datetime.css";


export const FormModalDiscountTest = (props) => {

    const {
        closeDialog, modal, method, methodAction,loading, handleInputChange, enable_discounts, currentExam, 

    } = props;
      

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                   <FormGroup className="mb-2 col-12">

                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        
                       
                        <Label className="col-form-label mb-0">
                        Aplicar descuento al {currentExam?.id_profile ? 'perfil' : 'exámen'}{" "}
                        <strong>{currentExam?.name}</strong>
                        </Label>
                         <Label className="switch mb-0">
                        <Input
                            type="checkbox"
                            name="enable_discounts"
                            onChange={handleInputChange}
                            checked={enable_discounts}
                        />
                        <span className="slider round"></span>
                        </Label>


                    </div>

                    </FormGroup>

            </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    // className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Guardar
                </Button>
                <Button
                    size="sm"
                    className="btn-air-light"
                    color="danger"
                    type="button"
                    onClick={closeDialog}
                >
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}


